<ng-container *ngIf="!isGridsterInMobileMode" [ngTemplateOutlet]="standardView"></ng-container>
<ng-container *ngIf="isGridsterInMobileMode" [ngTemplateOutlet]="miniModeView"></ng-container>

<ng-template #miniModeView>
    <toro-dashboard-widget-container
            [title]="title | translate"
            [titleIcon]="titleIcon"
            [showTitleIcon]="true"
            [showLinkButton]="true"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [menuStyleClass]="'toro-widget-menu spec-context-menu'"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            [isMiniModeWidget]="true"
            (gotoSite)="onLinkClick()"
    >
        <div class="toro-flex-child mini-mode-widget-container toro-component-shield-host">
            <img *ngIf="isDemoMode" id="i3-demo-img" src="../../../../../../assets/images/intelli360/intelli360-os-mini.png" class="prevent-select" alt="">

            <ng-container *ngIf="!isDemoMode" [ngTemplateOutlet]="summaryContent"></ng-container>
            <toro-component-shield (shieldClick)="onLaunchModalWidget()"></toro-component-shield>
        </div>

    </toro-dashboard-widget-container>
</ng-template>

<ng-template #standardView>
    <toro-dashboard-widget-container
            [title]="title | translate"
            [titleIcon]="titleIcon"
            [showTitleIcon]="true"
            [showLinkButton]="true"
            [isBusy]="isBusy"
            [lastUpdated]="lastUpdated"
            [associatedWidget]="associatedWidget"
            [widgetMenuItems]="widgetMenuItems"
            [menuStyleClass]="'toro-widget-menu spec-context-menu'"
            [analyticsWidgetName]="analyticsWidgetName"
            [(alertText)]="alertText"
            [(isUnableToFetchData)]="isUnableToFetchData"
            [unableToFetchDataReason]="unableToFetchDataReason"
            (gotoSite)="onLinkClick()"
    >

        <div class="toro-flex-child" id="spec-widget-content">

            <div *ngIf="displayCols == 1 && displayRows == 1" class="toro-widget-content-pane c1-r1" [ngClass]="{'fade-on-resize': isResizing && !isBusy, 'is-demo': isDemoMode}">
                <img *ngIf="isDemoMode" src="../../../../../../assets/images/intelli360/intelli360-os-1x1.png" class="prevent-select" alt="">

                <div *ngIf="!isDemoMode" class="i3-content-container d-flex fd-col">
                    <ng-container [ngTemplateOutlet]="oneByOneContent"></ng-container>
                </div>
            </div>

            <div *ngIf="displayCols == 1 && displayRows == 2" class="toro-widget-content-pane c1-r2" [ngClass]="{'fade-on-resize': isResizing && !isBusy}">
                <img *ngIf="isDemoMode" src="../../../../../../assets/images/intelli360/intelli360-os-1x2.png" class="prevent-select" alt="">

                <div *ngIf="!isDemoMode" class="i3-content-container d-flex fd-col">
                    <ng-container [ngTemplateOutlet]="oneByTwoContent"></ng-container>
                </div>
            </div>

        </div>

    </toro-dashboard-widget-container>
</ng-template>

<ng-template #titleIcon>
    <img *ngIf="isDemoMode" id="i360-title-icon" src="../../../../../../assets/images/intelli360/intelli360-os-logo.png" alt="">
</ng-template>

<ng-template #summaryContent>
    <div class="tmm-multi-content-panel-container toro-component-shield-host">
        <div class="toro-mini-mode-content-panel prevent-select" [ngClass]="language">
            <div id="tat-working-value" class="tat-datum-value"><span class="tmm-iv-value green">{{assetsOperatingCount || 0}}</span></div>
            <div class="tmm-ellipsis-text">{{'STRINGS.OPERATING' | translate}}</div>
        </div>
        <div class="toro-mini-mode-content-panel prevent-select">
            <div id="tat-idle-value" class="tat-datum-value"><span class="tmm-iv-value yellow">{{assetsIdleCount || 0}}</span></div>
            <div class="tmm-ellipsis-text">{{'STRINGS.IDLING' | translate}}</div>
        </div>
        <div class="toro-mini-mode-content-panel prevent-select">
            <div id="tat-transport-value" class="tat-datum-value"><span class="tmm-iv-value grey">{{assetsOffCount || 0}}</span></div>
            <div class="tmm-ellipsis-text">{{'STRINGS.OFF' | translate}}</div>
        </div>
        <div class="toro-mini-mode-content-panel prevent-select">
            <div id="tat-off-value" class="tat-datum-value"><span class="tmm-iv-value orange">{{assetsTowingCount || 0}}</span></div>
            <div class="tmm-ellipsis-text">{{'STRINGS.TOWING' | translate}}</div>
        </div>
    </div>
</ng-template>

<ng-template #oneByOneContent>
    <ng-container [ngTemplateOutlet]="summaryContent"></ng-container>

    <div id="i3-1x2-table-container">
        <toro-i3-table
                [assets]="assets?.assetsModel"
                [(selectedAsset)]="selectedAsset"
                (tableItemClick)="onTableItemClick($event)"
        ></toro-i3-table>
    </div>
</ng-template>

<ng-template #oneByTwoContent>
    <ng-container [ngTemplateOutlet]="summaryContent"></ng-container>

    <div id="i3-1x2-table-container">
        <toro-i3-table
                [assets]="assets?.assetsModel"
                [(selectedAsset)]="selectedAsset"
                (tableItemClick)="onTableItemClick($event)"
        ></toro-i3-table>
    </div>
    <div id="i3-map-btn" class="toro-component-shield-host">
        {{'CASE_SENSITIVE.OPEN_MAP' | translate}}
        <img src="../../../../../../assets/images/intelli360/i3-site-link.png" alt="">
        <toro-component-shield (shieldClick)="onShowMap()"></toro-component-shield>
    </div>
</ng-template>

<toro-mini-mode-widget-modal *ngIf="showMiniModeModal" (cancel)="showMiniModeModal = false">
    <div id="mini-mode-modal-content-container">
        <ng-container [ngTemplateOutlet]="oneByTwoContent"></ng-container>
    </div>
</toro-mini-mode-widget-modal>

<!--<toro-intelli360-modal-->
<!--        *ngIf="showDesktopModal"-->
<!--        [isMiniModal]="isGridsterInMobileMode"-->
<!--        [headerImgSrc]="'../../../../../../assets/images/intelli360/intelli360-os-logo.png'"-->
<!--        (gotoSite)="onLinkClick()"-->
<!--        (cancel)="showDesktopModal = false;"-->
<!--&gt;-->
<!--    <div id="i360-modal-content-container" [ngClass]="{'mini-modal': isGridsterInMobileMode}">-->
<!--        <img src="../../../../../../assets/images/intelli360/intelli360-maint-dt-modal.png" class="prevent-select" alt="">-->
<!--    </div>-->
<!--</toro-intelli360-modal>-->

